module.exports = __webpack_public_path__ + "static/media/quindio-51.857df7bd.jpg";